import React from 'react';
import { AlertTriangle, CheckCircle2, XCircle } from 'lucide-react';
import { fromApi } from '../../kit/time';

// One loan's TRID / HMDA / QM findings (GET /compliance/loans/:id/checks), as the
// Compliance page's checks dialog and the loan file's Audit & Dates tab show them.
export const CHECK_STATUS = {
  pass: { label: 'Pass', Icon: CheckCircle2, cls: 'text-emerald-600 bg-emerald-50' },
  warn: { label: 'Warn', Icon: AlertTriangle, cls: 'text-amber-700 bg-amber-50' },
  fail: { label: 'Fail', Icon: XCircle, cls: 'text-red-700 bg-red-50' },
};

export const TRID_RULES = new Set([
  'LE_3_biz_days_of_application',
  'CD_3_biz_days_before_consummation',
  'intent_before_le',
]);

// The checks count business days on the UTC calendar date, so show that date.
export const utcDate = (iso) => fromApi(iso).toLocaleDateString(undefined, { timeZone: 'UTC' });

export function ChecksList({ findings }) {
  return (
    <div className="space-y-2">
      {findings.map((f) => {
        const st = CHECK_STATUS[f.status] || CHECK_STATUS.warn;
        return (
          <div key={f.rule} className="flex items-start gap-3 p-3 rounded-lg border border-slate-100" data-testid={`check-${f.rule}`}>
            <span className={`text-xs px-2 py-1 rounded font-bold inline-flex items-center justify-center gap-1 w-16 shrink-0 ${st.cls}`} data-testid={`check-status-${f.rule}`}><st.Icon size={12} /> {st.label}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-brand-navy">{f.label}</div>
              {f.detail && <div className="text-xs text-slate-500">{f.detail}</div>}
              {f.dates?.length > 0 && (
                <div className="text-xs text-slate-500 mt-1">
                  {f.dates.map((d) => `${d.label}: ${utcDate(d.value)}`).join(' · ')}
                </div>
              )}
              {f.blocks?.length > 0 && (
                <div className="text-xs font-semibold text-red-700 mt-1" data-testid={`check-blocks-${f.rule}`}>
                  Holds a move to Closing or Funded until an owner or admin overrides it.
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
